import Service from "../service";

const auth = {
    onGetCategory() {
        return Service.get("/category");
    },
};

export default auth;